/*
 * NEXZ V2 — Collection/search analytics (Stage G)
 *
 * Same documented event-hook pattern as nexz-pdp.js: dispatches `nexz:*`
 * CustomEvents on `document`, no analytics destination wired here (a
 * later stage attaches a real listener). Reuses the real product-card
 * DOM (data-product-id, already present via product-card.liquid's own
 * `data-product-id` attribute) rather than adding new hooks per card.
 */
(function () {
  var EVENT_CONTRACT = ['view_item_list', 'select_item', 'search'];

  function nexzEmit(name, detail) {
    if (EVENT_CONTRACT.indexOf(name) === -1) return;
    document.dispatchEvent(new CustomEvent('nexz:' + name, { detail: detail || {}, bubbles: true }));
  }

  function cardIds(root) {
    return Array.prototype.map.call(root.querySelectorAll(CARD), function (el) {
      return el.getAttribute('data-product-id');
    });
  }

  // Horizon product cards, and the editorial collection's banners
  // (sections/nexz-editorial-collection.liquid).
  var CARD = 'product-card[data-product-id], [data-nexz-list-item][data-product-id]';

  function initGrid() {
    // results-list is Horizon's own native custom element, shared by
    // both sections/main-collection.liquid and sections/search-results
    // .liquid; the editorial collection marks its list with data-nexz-list.
    var root = document.querySelector('results-list, [data-nexz-list]');
    if (!root) return;

    var ids = cardIds(root);
    if (ids.length > 0) {
      nexzEmit('view_item_list', {
        listId: root.getAttribute('section-id') || undefined,
        productIds: ids,
      });
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('.product-card__link, .nxe-link') : null;
      if (!link) return;
      var card = link.closest(CARD);
      if (!card) return;
      var cards = Array.prototype.slice.call(root.querySelectorAll(CARD));
      var index = cards.indexOf(card);
      nexzEmit('select_item', {
        productId: card.getAttribute('data-product-id'),
        index: index,
      });
    });
  }

  function initSearch() {
    var root = document.querySelector('[data-nexz-search-performed]');
    if (!root || root.getAttribute('data-nexz-search-performed') !== 'true') return;
    nexzEmit('search', {
      query: root.getAttribute('data-nexz-search-query') || '',
      resultsCount: root.getAttribute('data-nexz-search-results-count') || '0',
    });
  }

  initGrid();
  initSearch();
})();
